export default __webpack_public_path__ + "static/media/technology_left.c7f4161b.png";